import React, { Component } from 'react';
import { Label } from 'reactstrap';
import { List, Divider } from '@material-ui/core';
import ItemListSentRequest from './ItemListSentRequest.js';
import {FormattedMessage} from 'react-intl';

class RequestsSent extends Component{

  createSentRequestsList(){
    if((this.props.requests_List !== undefined)&&(this.props.requests_List.length > 0)) {
      return(
        <List style={{ width: "100%", padding: "0", height: "content" }}>
          {this.props.requests_List.map((request) => {
            return(
              <ItemListSentRequest structure_Id={this.props.structure_Id} request={request} retrieveRequestsList={this.props.retrieveRequestsList}/>
            )
          })}
        </List>
      );
    } 
    else {
      return (
        <center>
          <Divider style={{ width: "100%", backgroundColor:"#000000", marginBottom: "5px" }} />
          <Label style={{ textAlign: "center", fontWeight: "bold" }}>
            <FormattedMessage id="invitation.noReq" defaultMessage="No request"/>
          </Label>
        </center>
      );
    }
  }
  
  render(){
    return (
      <div>
        {this.createSentRequestsList()}
      </div>
      );  
    }
  }
export default RequestsSent;